import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../../providers/common.service';
import { LoaderService } from '../../../../providers/loader.service';
import { PropertyListingService } from '../../../../providers/property-listing.service';
import { NewsTickerDetailsModel } from '../../../../models/NewsTickerDetailsModel';

@Component({
  selector: 'app-profile-tab',
  templateUrl: './profile-tab.component.html',
  styleUrls: ['./profile-tab.component.css']
})
export class ProfileTabComponent implements OnInit {

  constructor(private propertyListing: PropertyListingService, private Loader: LoaderService, private commonService: CommonService) { }
  profileData = {} as any;
  profileDetails = {} as any;
  @Input() tickerSymbol = "";
  newsDetail = {} as NewsTickerDetailsModel;
  quote = {} as any;
  ngOnInit() {
    this.Loader.display(true);
    this.getProfileDetails();
  }
  getProfileDetails() {
    this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6103).subscribe(response => {
      if (!response.IsLatestAvailable) {
        this.propertyListing.GetStockProfile(this.tickerSymbol).subscribe(result => {
          if (result != null) {
            this.profileDetails = result;
            this.profileData = this.profileDetails.quoteSummary.result[0]?.assetProfile || null;
            //this.quote = result["quoteType"];
            this.Loader.display(false);
            this.newsDetail.DataJson = JSON.stringify(result);
            this.newsDetail.Ticker = this.tickerSymbol;
            this.newsDetail.TypeId = 6103;
            this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(data => {
            });

          }
          else {
            this.Loader.display(false);
          }
        });
      }
      else {
        this.profileDetails = JSON.parse(response.DataJson);
        this.profileData = this.profileDetails.quoteSummary.result[0]?.assetProfile || null;
        //this.quote = JSON.parse(response.DataJson)["quoteType"];
        this.Loader.display(false);
      }
    });
  }
}
